import { ParseKeys } from "i18next";

/** Vendor tools follow the account's vendor, set from sign-up, approved or not. */
export const accountRole = (
  me: { vendor?: { id: number } | null } | null | undefined,
): "vendor" | "user" => (me?.vendor ? "vendor" : "user");

export interface DashboardMenuItem {
  label: ParseKeys<"dashboard">;
  path: string;
}

export const dashboardFeaturesVendor: DashboardMenuItem[] = [
  { label: "menu.profile", path: "profile" },
  { label: "menu.service_offerings", path: "serviceOfferings" },
  { label: "menu.leads", path: "leads" },
  // Estimates the vendor requested as a customer.
  { label: "menu.my_quotes", path: "quotes" },
  { label: "menu.messages", path: "messages" },
  { label: "menu.calendar", path: "calendar" },
  { label: "menu.meetings", path: "meetings" },
  { label: "menu.support", path: "support" },
];

export const dashboardFeaturesUser: DashboardMenuItem[] = [
  { label: "menu.profile", path: "profile" },
  { label: "menu.quotes", path: "quotes" },
  { label: "menu.messages", path: "messages" },
  { label: "menu.calendar", path: "calendar" },
  { label: "menu.support", path: "support" },
];

// Site-wide tools (analytics, vendor/user review, support inbox), so it belongs
// to neither role. Appended for whoever is in ADMIN_EMAILS, which the server
// resolves into Account.isAdmin.
const adminFeature: DashboardMenuItem = {
  label: "menu.admin",
  path: "admin",
};

// Only a rejected applicant can edit their application before resubmitting.
const applicationFeature: DashboardMenuItem = {
  label: "menu.application",
  path: "application",
};

export const dashboardFeaturesFor = (
  userType: "vendor" | "user",
  isAdmin = false,
  canEditApplication = false,
): DashboardMenuItem[] => [
  ...(userType === "vendor" ? dashboardFeaturesVendor : dashboardFeaturesUser),
  ...(canEditApplication ? [applicationFeature] : []),
  ...(isAdmin ? [adminFeature] : []),
];
